
/*----------------------
       SLIDER
---------------------- */
(function () {
  if (window.SectionSlider) return;

  window.SectionSlider = {
    init: function () {
      if (!window.Swiper) return;

      document.querySelectorAll(".swiper-sliderbig").forEach(function (slider) {
        if (slider.swiper || slider.querySelectorAll(".swiper-slide").length < 2) return;

        new Swiper(slider, {
          effect: "fade",
          loop: true,
          speed: 800,
          autoplay: {
            delay: 5000,
            disableOnInteraction: false,
          },
        });
      });
    },

    bindAnchorLinks: function () {
      if (window.SectionSlider._anchorLinksBound) return;
      window.SectionSlider._anchorLinksBound = true;

      document.addEventListener("click", function (event) {
        const link = event.target.closest(".swiper-sliderbig__link");
        if (!link) return;

        const href = link.getAttribute("href");
        if (!href || href === "#" || !href.startsWith("#")) return;

        const target = document.querySelector(href);
        if (!target) return;

        event.preventDefault();
        target.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    }
  };

  function initSliderWhenReady() {
    window.SectionSlider.init();
    window.SectionSlider.bindAnchorLinks();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initSliderWhenReady);
  } else {
    initSliderWhenReady();
  }

  document.addEventListener("shopify:section:load", function () {
    window.SectionSlider.init();
  });
})();
